export default "__VITE_ASSET__aaenEUvl__"